import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from "styled-components";
import * as React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    var isDark = useTheme().isDark;
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 31 29"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    x: "-50.0%",
                    y: "-50.0%",
                    width: "200.0%",
                    height: "200.0%",
                    filterUnits: "objectBoundingBox",
                    id: "filter-1",
                    children: [
                        /*#__PURE__*/ _jsx("feOffset", {
                            dx: "0",
                            dy: "2",
                            in: "SourceAlpha",
                            result: "shadowOffsetOuter1"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "2",
                            in: "shadowOffsetOuter1",
                            result: "shadowBlurOuter1"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
                            type: "matrix",
                            in: "shadowBlurOuter1",
                            result: "shadowMatrixOuter1"
                        }),
                        /*#__PURE__*/ _jsxs("feMerge", {
                            children: [
                                /*#__PURE__*/ _jsx("feMergeNode", {
                                    in: "shadowMatrixOuter1"
                                }),
                                /*#__PURE__*/ _jsx("feMergeNode", {
                                    in: "SourceGraphic"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "兑换首页",
                    transform: "translate(-1862.000000, -528.000000)",
                    fill: isDark ? "#C3C9D0" : "#002236",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "twitter",
                        transform: "translate(1851.000000, 514.000000)",
                        children: /*#__PURE__*/ _jsxs("g", {
                            id: "推特1",
                            filter: "url(#filter-1)",
                            transform: "translate(14.000000, 14.000000)",
                            children: [
                                /*#__PURE__*/ _jsx("rect", {
                                    id: "矩形",
                                    opacity: "0",
                                    x: "0",
                                    y: "0",
                                    width: "23.9996719",
                                    height: "23.9996719"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M21.5561584,7.85610027 C21.5561584,7.63096273 21.5518225,7.40837983 21.5418617,7.18732035 C22.5042392,6.47023641 23.3391887,5.57261587 23.9995781,4.54548147 C23.1027502,4.94901291 22.1484346,5.2100967 21.1710856,5.31930683 C22.188306,4.6933232 22.9684125,3.69220408 23.3370325,2.49081425 C22.3845924,3.06842354 21.3310443,3.48138664 20.2108877,3.69656339 C19.313361,2.67528829 18.0325425,2.02478937 16.6166088,2.00064908 C13.8972397,1.95567313 11.6928089,4.25371202 11.6928089,7.1327586 C11.6928089,7.54197175 11.7356052,7.93885695 11.8205415,8.32207828 C7.72555063,8.05857407 4.09681899,5.9270329 1.66952405,2.71372527 C1.24599078,3.48358974 1.00297066,4.38331963 1.00297066,5.34754863 C1.00297066,7.17124245 1.87230253,8.79211091 3.19310478,9.74858221 C2.38452209,9.71202021 1.62705588,9.46710168 0.962682151,9.06557592 L0.962682151,9.13255938 C0.962682151,11.6813995 2.66047144,13.8169485 4.91325314,14.3152229 C4.5002666,14.43269 4.06466318,14.4938142 3.61666149,14.4916111 C3.30539142,14.4900018 2.9951328,14.4560225 2.6908929,14.3902219 C3.31685309,16.4789433 5.13614072,18.0049615 7.28997064,18.0557968 C5.60429838,19.4535198 3.48084304,20.288399 1.17542143,20.2825632 C0.777926864,20.2825632 0.385119735,20.2558917 0,20.2075642 C2.17991551,21.7028563 4.76754419,22.5737823 7.54923273,22.5737823 C16.6041871,22.5759381 21.556135,14.6943896 21.556135,7.85610027 L21.5561584,7.85610027 Z",
                                    id: "路径"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
